import ajax from "@fdaciuk/ajax";
import Overlay from "../util/overlay";

export default {

    init() {},
    finalize() {
        jQuery(document).ready(function () {
            document.addEventListener('click', function (event) {
                if (event.target.classList.contains("next-posts-link")) {
                    event.preventDefault();
                    event.target.classList.add('waiting');
                    let href = (event.target.href.indexOf('?') > 0) ? event.target.href+'&ajax=true' : event.target.href+'?ajax=true';
                    if (event.target.parentElement.id == 'resource_navigation') {
                        loadMoreResources(href+'&view=resource');
                    } else if (event.target.parentElement.id == 'media_navigation') {
                        loadMoreMedia(href+'&view=media');
                    }
                }
            });

            $('.resource-link').on('click', function() {
                var title = $(this).data('title');

                gtag('event', 'click', {
                    'event_category' : 'Resource',
                    'event_label' : 'download',
                    'value' : title
                });
            });
        });

        function loadMoreMedia(href) {
            const site_resource_navigation = document.getElementById('media_navigation');
            const site_resource_container = document.querySelector('.media__container');

            if (href && site_resource_navigation && site_resource_container) {
                ajax().get(href).then(function (response, xhr) {
                    const faker = document.createElement('div');
                    faker.innerHTML = response;
                    let resources_navigation = faker.querySelector('#media_navigation');
                    let resources = faker.querySelectorAll('.resource.media');

                    for (let i = 0; i < resources.length; i++) {
                        site_resource_container.appendChild(resources[i]);
                    }

                    site_resource_navigation.innerHTML = resources_navigation.innerHTML;

                    /* Initialise added overlays */
                    let overlays = document.querySelectorAll('.overlay');
                    if (overlays !== null) {
                        for (var i = 0; i < overlays.length; i++) {
                            console.log(overlays[i].id);
                            let overlay_id = overlays[i].id;
                            let overlay = new Overlay({
                                trigger: document.querySelectorAll('.overlay__button--'+overlay_id)
                            });
                        }
                    }

                });
            }
        }

        function loadMoreResources(href) {
            const site_resource_navigation = document.getElementById('resource_navigation');
            const site_resource_container = document.querySelector('.resource__container');

            if (href && site_resource_navigation && site_resource_container) {
                ajax().get(href).then(function (response, xhr) {
                    const faker = document.createElement('div');
                    faker.innerHTML = response;
                    let resources_navigation = faker.querySelector('#resource_navigation');
                    let resources = faker.querySelectorAll('.resource.file');

                    for (let i = 0; i < resources.length; i++) {
                        site_resource_container.appendChild(resources[i]);
                    }

                    site_resource_navigation.innerHTML = resources_navigation.innerHTML;
                });
            }
        }
    },
};


// WEBPACK FOOTER //
// ./js/routes/resources.js